<template>
    <div class="divMargin">
        <div class="header">
            <p id="hrighttitle">TƏSDİQ EDİRƏM: <br> "Azərsığorta" DSKŞ</p>
            <h1 id="hrightform" class="header-info">Sədrin müşaviri _________________ C.Qurbanlı</h1>
            <div class="title-bottom">
                <p id="hrighttitle">Bakı şəhəri</p>
                <h1 id="hrightform" class="header-info">"____" _________ 2024-cü il</h1>
            </div>
            <p style="font-weight: bold;font-size: 16pt;"> SIĞORTA ÖDƏNİŞİ İLƏ BAĞLI AKT №: {{ item.dispClaimNumber }} </p>
        </div>
        <div class="content">
            <div class="section">
                <p class="section-title">1.SIĞORTA MÜQAVİLƏSİNƏ AİD MƏLUMATLAR:</p>
                <div class="info-row">
                    <p class="info-title">1.1 Sığortaçı:</p>
                    <p class="info-value">
                        {{  }}
                    </p>

                </div>
                <div class="info-row">
                    <p class="info-title">1.2 Sığorta şəhadətnaməsi №:</p>
                    <p class="info-value">{{ item.policyNumber }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">1.3 SŞ növü:</p>
                    <p class="info-value">{{ item.insuranceTypeName }}</p>
                </div>
                <br>
                <div class="info-row">
                    <p class="info-title">1.4 {{$t('Sığortalı')}}:</p>
                    <p class="info-value">{{ item.insuredName }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">1.5 Sığorta predmeti:</p>
                    <p class="info-value">{{ item.insuredDisplayName }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">1.6 Sığortanın başlama və bitmə tarixi:</p>
                    <p class="info-value">{{ item.startDateStr + '&nbsp;&nbsp;-&nbsp;&nbsp;' + item.endDateStr }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">1.7 Sığorta məbləği:</p>
                    <p class="info-value">{{ item.insuranceSum }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">1.8 {{$t('Sığorta_növü')}}:</p>
                    <p class="info-value">{{ item.policyTypeName }}</p>
                </div>
                <br>
                <p class="section-title">2.SIĞORTA HADİSƏSİNƏ DAİR MƏLUMATLAR:</p>
                <div class="info-row">
                    <p class="info-title">2.1 Hadisənin baş verdiyi tarix:</p>
                    <p class="info-value">
                        {{ item.accidentDateStr }}
                    </p>
                </div>
                <div class="info-row">
                    <p class="info-title">2.2 Məlumat vermə tarixi:</p>
                    <p class="info-value">{{ item.callDateStr }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">2.3 Sığorta hadisəsinin baş verdiyi ərazi:</p>
                    <p class="info-value">{{ item.place }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">2.4 Hadisədə zərərvuran şəxs:</p>
                    <p class="info-value">{{ item.injuredName }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">2.5 Hadisədə zərər çəkənlərin sayı:</p>
                    <p class="info-value">{{ item.vehicleCount }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">2.6 Zərərçəkən</p>
                    <p class="info-value">{{ item.victimName }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">2.7 Zərərçəkənin nömrəsi:</p>
                    <p class="info-value">{{ item.victimPhone }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">2.10 Zərər vurulmuş predmetə dair məlumat:</p>
                    <p class="info-value">{{ item.victimDisplayName }}</p>
                </div>
                <!-- <div class="info-row">
                    <p class="info-title">2.11 Sığorta hadisəsinin növü:</p>
                    <p class="info-value"> {{ item.damageCategoryName }}
                        <span v-if="item.damageCategoryName === 'Xəsarət'">
                            - {{ item.medDamageTypeName }}
                        </span>
                    </p>
                </div> -->
                <br>
                <div class="info-row">
                    <p class="info-title">2.12 Subroqasiya tələbinin mövcudluğuna dair məlumat:</p>
                    <p class="info-value">{{item.subragationStatusName}}</p>
                </div>
                <br>
                <p class="section-title">3.DƏYMİŞ ZƏRƏR BARƏDƏ MƏLUMAT:</p>
                <div class="info-row">
                    <p class="info-title">3.1 Zərəri müəyyən edən müəssisə:</p>
                    <p class="info-value">{{item.basisPrice}}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">3.2 Zərərin müəyyən edildiyi tarix:</p>
                    <p class="info-value">{{ item.damageDateStr}}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">3.3 Ümumi zərər məbləği:</p>
                    <p class="info-value">{{ item.damageSumLetter }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">3.4 Zərərçəkənin zərərdə payı:</p>
                    <p class="info-value">{{item.damagePercentage}}</p>
                </div>
                <br>
                <p class="section-title">4.SIĞORTA ÖDƏNİŞİ:</p>
                <div class="info-row">
                    <p class="info-title">4.1 Hesablanmış sığorta ödənişi:</p>
                    <p class="info-value">{{ item.paymentSumLetter}}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">4.2 Sığorta ödənişini alan:</p>
                    <p class="info-value">{{ item.paymentReceivedPerson}}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">4.3 Telefon nömrəsi:</p>
                    <p class="info-value">{{ item.paymentReceivedPersonPhone }}</p>
                </div>
            </div>
            <br>
            <p class="section-title">5. YEKUN MÜDDƏALAR:</p>
            <p class="content-footer">Sığortalı və ya zərərçəkən üçüncü şəxs təsdiq edir ki, bu sığorta aktı ilə müəyyən
                edilmiş sığorta
                ödənişi sığorta hadisəsi nəticəsində dəymiş zərərin əvəzinin ödənilməsi üçün qətidir.
                <br>
                Sığortalı və ya faydalanan şəxs həmçinin, təsdiq edir ki, mövcud şəhadətnamədə göstərilən risklər üzrə
                mənafelərini digər heç bir sığortaçıda sığortalamamışdır və baş vermiş sığorta hadisəsi nəticəsində
                dəymiş zərərə
                görə heç bir digər ödəniş almır.
            </p>
            <br>
            <div class="info-row">
                <p class="info-title">Departament direktoru:</p>
                <p class="info-value">V.Kərimov</p>
            </div>
            <div class="info-row">
                <p class="info-title">Sığorta hadisələri şöbəsinin müdiri:</p>
                <p class="info-value">Dəyanət Babayev</p>
            </div>
            <div class="info-row">
                <p class="info-title">Mütəxəssis(icraçı):</p>
                <p class="info-value">Nurlanə Ələkbərova</p>
            </div>
            <div class="info-row">
                <p class="info-title">Sığorta iddialarının tənzimlənməsi şöbəsinin müdiri:</p>
                <p class="info-value">E.Sofiyev</p>
            </div>






        </div>
        <div class="date">
            <span>Aktın çap tarixi və vaxtı: {{ currentDateTime }}</span>
            <span><strong>Tarix: "____" ________ 2024-cü il</strong></span>
        </div>
    </div>
</template>



<script>
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            item: this.value,
            currentDateTime: new Date().toLocaleString('tr-TR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }),
        };
    },
    watch: {
        value() {
            this.item = this.value;
        },
    },
};
</script>

<style lang="scss" scoped>
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: black !important;
    /* Set default text color to black */
    text-align: left;
    background-color: #fff;
}

.date {
    width: 90%;
    color: black !important;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 15px;
}
.header-info{
    font-weight: 600;
      font-size: var(--font-medium) !important;
}
.content-footer {
    width: 77.6%;
    margin-left: 25px;
}

.header {
    font-size: 18px;
    text-align: center;
    margin-bottom: 2px;
    color: black;
    /* Set text color to black */
}

.note {
    font-size: smaller;
    /* Daha küçük font boyutu */
    text-align: left;
    /* Metni sola hizala */
    width: 50%;
    /* Veya istediğiniz başka bir genişlik */
    padding: 5px;
    /* İç boşluğu ayarla */
    box-sizing: border-box;
    /* Padding'i genişliğe dahil et */
}


.content {
    font-size: 16px;
    color: black;
    /* Set text color to black */
}

.footer {
    text-align: right;
    margin-top: 2px;
    font-weight: bold;
    color: black;
    /* Set text color to black */
}

.footer>div {
    display: flex;
    justify-content: space-between;
}

.section-title {
    font-weight: 700;
    margin-top: 10px;
    color: black;
    font-size: 14pt;
    /* Set text color to black */
}

#hrighttitle {
    text-align: right;
    font-weight: bold;
    color: black;
    font-size: 15pt;
    /* Set text color to black */
}

#hrightform {
    color: black;
    /* Set text color to black */
    font-size: smaller;
    text-align: right; 
    margin-top: 15px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
}

.info-title,
.info-value {
    width: 50%;
    margin: 0;
}

.info-title {
    text-align: left;
    padding-right: 10px;
    font-size: 15pt;
}

.info-value {
    text-align: left;
    padding-left: 10px;
    font-size: 15pt;
}

@media print {
    .divMargin {
        padding: 5% !important;
    }
}

.divMargin {
    padding: 5%;
}

h4 {
    text-decoration: underline;
    color: black;
    /* Set text color to black */
}

.title-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>